export default "__VITE_ASSET__70decd98__"